module.exports = __webpack_public_path__ + "static/media/plus-icon.ca0a7e5d.svg";